import React, { useEffect, useState } from "react";

const QuantityInput = ({
  segment,
  stepSize = 1,
  minValue = 1,
  value,
  onChange,
  setHasError, // LIFTED error flag
  tabChanging,
}) => {
  const [error, setError] = useState("");

  useEffect(() => {
    setError("");
  }, [tabChanging]);

  useEffect(() => {
    // Expose error state to parent
    setHasError(!!error);
  }, [error, setHasError]);

  const handleChange = (e) => {
    let val = e.target.value;
    onChange(val);
    // Block any characters that aren't digits or dot

    if (val < 0) {
      setError("Negative values not allowed.");
      return;
    }

    const str = val.toString().trim();
    if (/[^0-9.]/.test(str)) {
      setError("Only numeric values allowed.");
      return;
    }

    if (/[^0-9.]/.test(val)) {
      setError("Enter a valid amount.");
      return;
    }

    // Prevent multiple dots
    if ((val.match(/\./g) || []).length > 1) {
      setError("Only one decimal point allowed.");
      return;
    }

    // Prevent leading 0s like 00.12 unless it's 0.
    if (/^0\d+/.test(val)) {
      setError("Invalid leading zero format.");
      return;
    }

    setError(""); // Reset error

    if (!val) {
      setError("This field is required.");
      return;
    }

    const [intPart] = val.split(".");
    if (intPart.length > 8) {
      setError("Max 8 digits allowed before decimal.");
      return;
    }

    const numeric = parseFloat(val);
    if (!isNaN(numeric) && numeric < minValue) {
      setError(
        `Specified value is less than the instrument minimum of ${minValue}.`
      );
      return;
    }

    if (segment === "equity" && !/^\d*$/.test(val)) {
      setError("Equity quantity must be a whole number.");
      return;
    }

    if (segment === "forex" && !/^\d*\.?\d{0,2}$/.test(val)) {
      setError("Forex quantity must be max 2 decimal places.");
      return;
    }

    if (segment === "crypto") {
      const allowedDecimals = stepSize.toString().split(".")[1]?.length || 0;
      const regex = new RegExp(`^\\d*\\.?\\d{0,${allowedDecimals}}$`);
      if (!regex.test(val)) {
        setError(`Crypto allows max ${allowedDecimals} decimals.`);
        return;
      }
    }
  };

  const handleBlur = () => {
    if (!value) return;

    const numeric = parseFloat(value);
    if (isNaN(numeric)) {
      setError("Number format is invalid.");
      return;
    }

    if (numeric < minValue) {
      setError(
        `Specified value is less than the instrument minimum of ${minValue}.`
      );
      return;
    }

    if (value.endsWith(".")) {
      onChange(value.slice(0, -1));
    }
  };

  return (
    <div style={{ position: "relative", marginBottom: "10px" }}>
      {error && (
        <div
          style={{
            // color: "#ffd700",
            background: "#333",
            padding: "6px 8px",
            borderRadius: "4px",
            marginBottom: "4px",
            fontSize: "12px",
            position: "absolute",
            top: "-43px",
            minHeight: "40px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            textAlign: "center",
          }}
        >
          {error}
        </div>
      )}
      <input
        type="text"
        inputMode="decimal"
        // pattern="[0-9]*"
        onBlur={handleBlur}
        value={value}
        onChange={handleChange}
        placeholder="Enter Quantity"
        style={{
          border: error ? "2px solid #e40058" : "",
          borderRadius: "4px",
        }}
      />
    </div>
  );
};

export default QuantityInput;
